import '@swf/core/src/css/main.scss';
import '@swf/core/src/css/sw-lightTheme.scss';

import './css/des-acc.css';

// Enable following if there is any requirement
// import './acc/project/des-list-projects-as-image';
import './acc/project/des-list-projects-as-list';

import './acc/project/des-list-projects-as-listbox';
import './acc/project/des-create-project';
import './acc/project/des-navigate-project-contents-as-list';
import './acc/project/des-navigate-project-contents-as-table';
import './acc/project/des-search-results-as-table';
import './acc/project/des-search-results-as-list';
import './acc/project/des-search-box';
import './acc/project/des-ownership-lov';
import './acc/project/des-search-facets';
import './acc/utils/des-collab-progress-bar';
import './acc/rfq/des-list-rfqs-as-list';
import './acc/rfq/des-create-rfq';
import './acc/rfq/des-list-suppliers-as-list';
import './acc/rfq/des-add-supplier';
import './acc/rfq/des-get-rfq-details';
import './acc/rfq/des-view-rfq';
import './acc/rfq/des-my-rfqs';
import './acc/rfq/des-list-rfq-contents';
import './acc/rfq/des-submit-rfq';
import './acc/rfq/des-get-rfq-quote-details';
import './acc/rfq/des-list-rfq-quote-contents';
import './acc/rfq/des-view-rfq-quote';
import './acc/rfq/des-list-rfq-quotes-as-list';
import './acc/rfq/des-add-contents-rfq';
import './acc/rfq/des-submit-rfq-quote';
import './acc/rfq/des-process-rfq-quote';
import './acc/rfq/des-award-rfq';
import './acc/rfq/des-close-rfq';
import './acc/rfq/des-list-rfq-quote-contents-of-rfq';
import './acc/rfq/des-copy-content-to-rfq';

// Importer
import './acc/importer/des-import-data';
import { registerDynImportEntry } from 'js/moduleLoader';

// Required for table sort & filter options in aw
import 'js/aw_polyfill';

// Team Module
import './acc/team/des-collab-create-team';
import './acc/team/des-create-team-main-panel';
import './acc/team/des-create-team-sub-panel';
import './acc/team/des-collab-edit-team';
import './acc/team/des-edit-team-main-panel';
import './acc/team/des-edit-team-sub-panel';
import './acc/team/des-team-list';
import './acc/team/des-team-contents';
import './acc/team/des-user-list';

// lov service
registerDynImportEntry('js/lovService', () => import('js/lovService'));

// view models
registerDynImportEntry('viewmodel/CreateRfqCommandPanelViewModel', () => import('viewmodel/CreateRfqCommandPanelViewModel'));
registerDynImportEntry('viewmodel/AddSupplierCommandPanelViewModel', () => import('viewmodel/AddSupplierCommandPanelViewModel'));
registerDynImportEntry('viewmodel/AwardRfqCommandPanelViewModel', () => import('viewmodel/AwardRfqCommandPanelViewModel'));
registerDynImportEntry('viewmodel/AddContentsCommandPanelViewModel', () => import('viewmodel/AddContentsCommandPanelViewModel'));
registerDynImportEntry('viewmodel/SubmitRfqCommandPanelViewModel', () => import('viewmodel/SubmitRfqCommandPanelViewModel'));
registerDynImportEntry('viewmodel/CloseRfqCommandPanelViewModel', () => import('viewmodel/CloseRfqCommandPanelViewModel'));

registerDynImportEntry('viewmodel/SubmitRfqQuoteCommandPanelViewModel', () => import('viewmodel/SubmitRfqQuoteCommandPanelViewModel'));
registerDynImportEntry('viewmodel/AcknowledgeProcessRfqQuoteCommandPanelViewModel', () => import('viewmodel/AcknowledgeProcessRfqQuoteCommandPanelViewModel'));
registerDynImportEntry('viewmodel/NoQuoteProcessRfqQuoteCommandPanelViewModel', () => import('viewmodel/NoQuoteProcessRfqQuoteCommandPanelViewModel'));
registerDynImportEntry('viewmodel/CustomCommandsViewModel', () => import('viewmodel/CustomCommandsViewModel'));
registerDynImportEntry( `viewmodel/AwPopupCommandBarViewModel`, () => import( `viewmodel/AwPopupCommandBarViewModel` ) );
registerDynImportEntry('viewmodel/ExtendedTooltipDefaultViewModel', () => import('viewmodel/ExtendedTooltipDefaultViewModel'));
registerDynImportEntry('viewmodel/AwTableCommandBarViewModel', () => import('viewmodel/AwTableCommandBarViewModel'));
registerDynImportEntry('viewmodel/splmTableTextColumnMenuViewModel', () => import('viewmodel/splmTableTextColumnMenuViewModel'));
registerDynImportEntry('viewmodel/ArrangeColumnsViewModel', () => import('viewmodel/ArrangeColumnsViewModel'));

// Icon list
registerDynImportEntry('image/cmdOpen24.svg', () => import('image/cmdOpen24.svg'));
registerDynImportEntry('image/cmdClearText24.svg', () => import('image/cmdClearText24.svg'));
registerDynImportEntry('image/cmdHistory24.svg', () => import('image/cmdHistory24.svg'));
registerDynImportEntry('image/cmdSearch16.svg', () => import('image/cmdSearch16.svg'));
registerDynImportEntry('image/cmdSettings24.svg', () => import('image/cmdSettings24.svg'));
registerDynImportEntry('image/indicatorWarningSign16.svg', () => import('image/indicatorWarningSign16.svg'));
registerDynImportEntry('image/miscChevronLeft24.svg', () => import('image/miscChevronLeft24.svg'));
registerDynImportEntry('image/miscChevronLeftDouble24.svg', () => import('image/miscChevronLeftDouble24.svg'));
registerDynImportEntry('image/miscChevronRight16.svg', () => import('image/miscChevronRight16.svg'));
registerDynImportEntry('image/miscChevronRight24.svg', () => import('image/miscChevronRight24.svg'));
registerDynImportEntry('image/miscChevronUp16.svg', () => import('image/miscChevronUp16.svg'));
registerDynImportEntry('image/miscChevronUp24.svg', () => import('image/miscChevronUp24.svg'));
registerDynImportEntry('image/miscChevronDown16.svg', () => import('image/miscChevronDown16.svg'));
registerDynImportEntry('image/miscChevronDown24.svg', () => import('image/miscChevronDown24.svg'));
registerDynImportEntry('image/miscSortedAscending10.svg', () => import('image/miscSortedAscending10.svg'));
registerDynImportEntry('image/miscSortedDescending10.svg', () => import('image/miscSortedDescending10.svg'));
registerDynImportEntry('image/miscUnSorted10.svg', () => import('image/miscUnSorted10.svg'));
registerDynImportEntry('image/typePart48.svg', () => import('image/typePart48.svg'));
registerDynImportEntry('image/typeProjectContract48.svg', () => import('image/typeProjectContract48.svg'));
registerDynImportEntry('image/typeFolder48.svg', () => import('image/typeFolder48.svg'));
registerDynImportEntry('image/cmdAdd24.svg', () => import('image/cmdAdd24.svg'));
registerDynImportEntry('image/cmdTime16.svg', () => import('image/cmdTime16.svg'));
registerDynImportEntry('image/cmdCalendar16.svg', () => import('image/cmdCalendar16.svg'));
registerDynImportEntry('image/uiPrimeNavGripper16.svg', () => import('image/uiPrimeNavGripper16.svg'));
registerDynImportEntry('image/cmdShareCheckout24.svg', () => import('image/cmdShareCheckout24.svg'));
registerDynImportEntry('image/cmdClosePanel24.svg', () => import('image/cmdClosePanel24.svg'));
registerDynImportEntry('image/cmdDelete24.svg', () => import('image/cmdDelete24.svg'));
registerDynImportEntry('image/cmdEdit24.svg', () => import('image/cmdEdit24.svg'));
registerDynImportEntry(`image/cmdBack24.svg`, () => import(`image/cmdBack24.svg`));
registerDynImportEntry(`image/cmdRemove24.svg`, () => import(`image/cmdRemove24.svg`));
registerDynImportEntry('image/cmdCancelEdit24.svg', () => import('image/cmdCancelEdit24.svg'));
registerDynImportEntry('image/cmdSave16.svg', () => import('image/cmdSave16.svg'));
registerDynImportEntry(`image/miscDownArrow_uxRefresh12.svg`, () => import(`image/miscDownArrow_uxRefresh12.svg`));
registerDynImportEntry(`image/cmdMore16.svg`, () => import(`image/cmdMore16.svg`));
registerDynImportEntry('image/cmdAwardQuote16.svg', () => import('image/cmdAwardQuote16.svg'));
registerDynImportEntry('image/cmdClose16.svg', () => import('image/cmdClose16.svg'));
registerDynImportEntry('image/cmdSendRequestToReceiveQuotations16.svg', () => import('image/cmdSendRequestToReceiveQuotations16.svg'));
registerDynImportEntry('image/cmdAcknowledgeQuote16.svg', () => import('image/cmdAcknowledgeQuote16.svg'));
registerDynImportEntry('image/cmdRejectQuote16.svg', () => import('image/cmdRejectQuote16.svg'));
registerDynImportEntry('image/cmdQuoteRequestsList16.svg', () => import('image/cmdQuoteRequestsList16.svg'));
registerDynImportEntry('image/cmdHide16.svg', () => import('image/cmdHide16.svg'));

// analytics
// registerDynImportEntry('js/splmAnalyticsService', () => import('js/splmAnalyticsService'));
registerDynImportEntry('js/splmTableMenuUtility', () => import('js/splmTableMenuUtility'));
// import analyticsService from 'js/analyticsService';
// import _cfgSvc from 'js/configurationService';


// date time service
import( 'js/dateTimeService' ).then( function(dateTimeSvc){ dateTimeSvc.init();} );

// accProviders is set on window object only by the microapp. Test harness, Zel X and XShare do not set this
// Where do we use the awConfiguration.get('baseUrl') ? Did not find any reference in des-collab-acc repo. 
// Need to check with Seth
// import awConfiguration from 'js/awConfiguration';
// const accEndpoint = window.accProviders ? window.accProviders['des-collab-acc']?.accEndpoint : '';
// awConfiguration.set('baseUrl', `${accEndpoint}/assets`);

/*
const initializeAnalytics = () => {
    var solution;
    analyticsService.authenticationSuccessful();
    analyticsService.enable(true).then(function () {
        return _cfgSvc.getCfg('solutionDef');
    }).then(function (solutionDef) {
        solution = solutionDef;
        return _cfgSvc.getCfg('versionConstants');
    }).then(function (versionConstants) {
        var property = {};
        _.set(property, 'environment', 'INT'); // shouldn't this come from build step?
        _.set(property, 'clientVersion', versionConstants.version);
        _.set(property, 'serverVersion', versionConstants.version);
        _.set(property, 'AW Client Width', parseInt(window.innerWidth));
        _.set(property, 'AW Client Height', parseInt(window.innerHeight));
        _.set(property, 'Browser Zoom Level', Math.round(window.devicePixelRatio * 100));
        _.set(property, 'Participating', true);
        analyticsService.logEvent(solution.solutionId, property);
        analyticsService.logProductInfo('environment', 'INT'); // shouldn't this come from build step?
    });
}
initializeAnalytics();
*/
